var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilterDial = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.903 8.754V.98a.97.97 0 0 0-.979-.98.97.97 0 0 0-.98.98v7.774a3.503 3.503 0 0 0-2.507 3.37c0 1.567 1.058 2.939 2.507 3.33v3.566c0 .549.431.98.98.98a.97.97 0 0 0 .98-.98v-3.565c1.45-.431 2.507-1.763 2.507-3.33a3.503 3.503 0 0 0-2.508-3.37Zm-.979 4.859a1.53 1.53 0 0 1-1.528-1.528 1.53 1.53 0 0 1 1.528-1.528 1.53 1.53 0 0 1 1.528 1.528c0 .783-.666 1.528-1.528 1.528Zm-6.857-9.93V.98a.97.97 0 0 0-.98-.98.97.97 0 0 0-.98.98v2.703A3.503 3.503 0 0 0 2.6 7.053c0 1.567 1.058 2.939 2.508 3.33v8.637c0 .549.43.98.98.98a.97.97 0 0 0 .979-.98v-8.636c1.45-.431 2.508-1.763 2.508-3.331a3.503 3.503 0 0 0-2.508-3.37Zm-.98 4.859A1.53 1.53 0 0 1 4.56 7.014a1.53 1.53 0 0 1 1.528-1.528 1.53 1.53 0 0 1 1.529 1.528 1.53 1.53 0 0 1-1.529 1.528Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilterDial);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/filter-dial.aa387e2b2505bf55021b49a4e170b591.svg";